var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.haveBookingRequest
    ? _c("div", [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "container-fluid" },
          [
            _c(
              "booking-form",
              {
                attrs: {
                  "property-mutator": _vm.setRequestProperty,
                  booking: _vm.booking,
                  "validation-triggered": _vm.validationTriggered,
                },
              },
              [
                _c("booking-edit-shortlist", {
                  attrs: { slot: "shortlist", booking: _vm.booking },
                  slot: "shortlist",
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "dashboard-block" },
              [
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: { click: _vm.handleSaveRequestCallback },
                  },
                  [_vm._v("\n        Save Request\n      ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Edit Request")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }